import * as React from "react";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import kolibriLogo from "../sources/колибри.png";

const Header = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (path) => {
    const token = localStorage.getItem("api_token");
    if (token) {
      navigate(path);
    } else {
      navigate("/");
    }
    handleMenuClose();
  };

  const handleMainClick = () => {
    const token = localStorage.getItem("api_token");
    if (token) {
      navigate("/active-users");
    } else {
      navigate("/");
    }
  };

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#fafafa",
        color: "#000",
        boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
      }}
    >
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          <Button color="inherit" onClick={handleMainClick}>
            <img
              src={kolibriLogo}
              alt="Logo"
              style={{ height: "40px", objectFit: "contain" }}
            />
          </Button>
        </Typography>
        <Box>
          <IconButton
            color="inherit"
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleMenuClick}
          >
            <MenuIcon />
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={() => handleMenuItemClick("/home")}>
              Главная
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("/search")}>
              Поиск
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("/active-users")}>
              Активные пользователи
            </MenuItem>
            <MenuItem
              onClick={() => handleMenuItemClick("/segmentation-table")}
            >
              Таблица сегментация
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("/ban-list")}>
              Бан лист
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("/lots")}>
              Количество лотов
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("/search-customers")}>
              Псевдонимы
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("/List-Log")}>
              Анализ список-логи
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("/test-request")}>
              Тестовый запрос
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("/satu-analyzer")}>
              Satu Analyzer
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("/ktru-sources")}>
              Источники по КТРУ
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("/backfill")}>
              Backfill
            </MenuItem>
            {/* <MenuItem onClick={() => handleMenuItemClick("/backfill-mongo")}>
              Backfill Mongo с Postgre
            </MenuItem> */}
            <MenuItem onClick={() => handleMenuItemClick("/lot-status")}>
              Лот статус
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
